module.exports = __webpack_public_path__ + "static/media/Shocklatesmoothie.89214bbb.png";